<template>
  <div class="swipeHint">
    <Popup :close-on-click-overlay="false" class="popup_box" v-model="isShow">
      <div class="container">
        <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
          <Icon class="navbar_icon" name="arrow-left" @click="$router.back(1)"/>
          <span>請簽署借貸合同</span>
          <div class="icon_box"></div>
        </div>

        <!--        <pdf v-for="i in pageNum" :key="i" :src="file" :page="i"></pdf>-->
        <div class="contract" ref="imageDom">
          <p><strong>金錢消費借貸契約</strong></p>
          <p>立契約書人</p>
          <p>貸   與   人：<u>      准借     </u>（以下簡稱甲方）
          </p>
          <p>
            借   用   人：<u>          {{
              formData.real_name
            }}         </u>（以下簡稱乙方）
          </p>
          <p> </p>
          <p>茲就金錢消費借貸事件，訂立本契約，雙方同意之條件如下：</p>
          <p><strong>第一條</strong><strong> </strong><strong>（借貸金額）</strong></p>
          <p>甲方同意將金錢新臺幣（下同）<u>    {{ loanAmount?loanAmount:loanInfo.paymentAmount }}    </u> 元貸與乙方，而乙方願依本 契約借用之。
          </p>
          <p><strong>第二條</strong><strong> </strong><strong>（借貸利息）</strong></p>
          <p>本金錢借貸之利息以年利率百分之   16  ％    計算（即月利率：</p>
          <p>
            1.33％），至借款債務清償完畢為止。 （利息計算方式為按月計息，採 本金乘以年利率，再除以十二即得 每月之利息額。不足一個月之畸零  天數部分，則按日計息）。</p>
          <p><strong>第三條</strong><strong> </strong><strong>（交付方式）</strong></p>
          <p>本契約第一條所示之借貸金額，於扣除第二條所定之利息、服務費及   平台 App 維護費後，甲方以現金方式匯入乙方指定之銀行帳戶，作 為 借款之交付，並經乙方收訖無誤。</p>
          <p><strong>第四條</strong><strong> </strong><strong>（借貸期間）</strong></p>
          <p>借貸期間自民國（下同）<u>   {{ dateData.startDate.year }}   </u> 年 <u>   {{
              dateData.startDate.month
            }}   </u> 月<u>   {{ dateData.startDate.date }}   </u> 日起至<u>   {{
              dateData.endDate.year
            }}      </u> 年<u>   {{ dateData.endDate.month }}   </u> 月<u>   {{
              dateData.endDate.date
            }}   </u> 日止。到期後依平台
            App 上通知繳交展延費後即得以展延。</p>
          <p><strong>第五條</strong><strong> </strong><strong>（清償方式）</strong></p>
          <p>乙方應自第三條所定之借貸期間屆滿時，應如數清償第一條所示之 借 貸金額，不得為部分清償或怠於履行。</p>
          <p><strong>第六條</strong><strong> </strong><strong>（損害賠償）</strong></p>
          <p>乙方如未依本契約履行者，甲方除得命限期履行外，如乙方因未履 行 本契約約定所生之費用及損害（包括但不限於訴訟費用、律師費 用</p>
          <p>等），違約之一方應賠償上揭費用、損害及自支付費用或損害發 生之日 起，按週年利率百分之 <u>    {{ loanInfo.rate }}    </u> 計算之利息。 因可歸責於任一方之事由 致本契約解除者，他方得請求所受損害之 違約金，違約之一方並應負  擔他方因契約解除所受之其他損害。
          </p>
          <p><strong>第七條</strong><strong> </strong><strong>（懲罰性違約金）</strong></p>
          <p>乙方若於本契約第二條所定之清償日屆至未清償第一條所示之借貸 金 額全部，同意支付甲方 10% ，作為懲罰性之違約金。</p>
          <p><strong>第八條</strong><strong> </strong><strong>（管轄法院）</strong></p>
          <p>雙方約定嗣後如有訟爭，以臺灣<u> </u><u>臺北</u><u> </u>地方法院為管轄法院。</p>
          <p><strong>第九條（送達條款）</strong></p>
          <p>任何基於本契約之通知或其他文件之送達，其送達地址均以本契約 時 雙方所載之地址為準。送達地址如有變更，該變更之一方應以書 面通 知他方，如變更之一方怠於通知致他方之通知或文件遭退回 時，則以 第一次投遞之時為送達之時。</p>
          <p><strong>第十條</strong><strong> </strong><strong>（其他）</strong></p>
          <p>本契約未定明事項依中華民國相關法令辦理之。本人因經濟收入不敷使用，亦曾向其他民間有過借貸之經驗，幾經思考後，今透過廣告諮詢借貸乙事，已全明瞭且同意借貸計息與付款方式，今幸蒙 帮助不勝感激，在此聲明願放棄對刑法第344、345 條重利事實及個資法之相關法律權，本人實為心甘情願，特此證明。本契約壹式貳份，由雙方各執壹份為憑。</p>
          <p> </p>
          <p class="contract_tips">
            <strong>*</strong><strong>特別提醒：借款前應務必先審慎評估、了解自己還款</strong><strong> </strong><strong>能</strong><strong> </strong><strong>力。</strong><strong> </strong><strong>切勿在輕率、急迫、無經驗之時向他人借款。</strong>
          </p>
          <p> </p>
          <p>立契約書人</p>
          <p> </p>
          <p>貸 與 人  ：<u>       准借       </u>
          </p>
          <p> </p>
          <p> </p>
          <p class="signatureOfAContract_box">借 用 人  ：<u v-if="!signatureBase64">              </u><img
              class="signatureOfAContract" v-if="signatureBase64" :src="signatureBase64" alt="">
          </p>
          <p>身分證字號：<u>       {{ formData.no_ktp }}        </u>
          </p>
          <p>地      址  ：<u>         {{
              address
            }}         </u>
          </p>
          <p> </p>
          <p> </p>
          <p>中華民國<u>    {{ dateData.startDate.year }}    </u>年<u>   {{
              dateData.startDate.month
            }}   </u> 月<u>   {{ dateData.startDate.date }}   </u> 日
          </p>

        </div>
        <div class="contract_signature">
          <div class="contract_signature_title">
            貸款人簽名:
          </div>
          <div @click="signature" class="contract_signature_img_box">
            <div v-if="!signatureBase64">請點擊進行簽名</div>
            <img v-if="signatureBase64" :src="signatureBase64" alt="">
            <!--                          <VueSignaturePad-->
            <!--                              width="100%"-->
            <!--                              height="100%"-->
            <!--                              ref="signaturePadShow"-->
            <!--                              :options="options"-->
            <!--                          />-->
          </div>
          <div class="contract_signature_btn_box">
            <Button class="popup_close popup_close2" @click="reSign">重新簽名</Button>
            <Button class="popup_close" @click="confirmationSignature">確認簽署</Button>
          </div>
        </div>
        <!--        <img style="width: 100%;" :src="imgUrl" alt="">-->
      </div>
    </Popup>

    <Popup :close-on-click-overlay="false" class="popup_box" v-model="isShowDrawing">
      <div class="signaturePad" ref="view">
        <div class="signaturePad_content">
          <div class="popup_content_SignaturePad">
            <VueSignaturePad
                width="100%"
                height="100%"
                ref="signaturePad"
                :options="options"
            />
          </div>
          <div class="signaturePad_content_text">
            <div class="signaturePad_content_btn" @click="confirmSignature">确定</div>
            <div class="signaturePad_content_btn" @click="undo">撤销</div>
            <div class="signaturePad_content_btn" @click="clear">清空</div>
            <div class="signaturePad_content_btn" @click="cancelSignature">取消</div>
          </div>
        </div>
      </div>
    </Popup>

    <Popup class="popup_flip_box" overlay-class="popup_flip_overlay" :close-on-click-overlay="false"
           v-model="showOverlay">
      <div class="popup_flip_wrapper" @click.stop>
        请翻转为横屏进行签名
        <img src="@/assets/icon/flip.png" alt="">
      </div>
    </Popup>
  </div>
</template>

<script>
import {Icon, Popup, Button, Toast} from "vant";
import l from "@/locales";
import {loanInformation, queryUserBase} from "@/services/information";
// import Pdf from 'vue-pdf'
import moment from "moment";
import html2canvas from "html2canvas"
import screenfull from 'screenfull'
// import {lrzUploadImage} from "@/services/upload";


export default {
  name: "swipeHint",
  components: {
    Icon, Popup, Button,
    // Pdf
  },
  props: {
    show: {
      type: Boolean,
    },
    loanAmount:{
      type : [String,Number]
    }
  },
  data() {
    return {
      isShow: this.show,
      l: {...l.idCard, ...l.work, ...l.login},
      file: "/contractSignature.pdf",
      pageNum: 1,
      isShowDrawing: false,

      panelVisible: false,
      panelTitle: "",
      options: {
        penColor: "#000",
        // minWidth: 1,    //控制画笔最小宽度
        // maxWidth: 1,    //控制画笔最大宽度
      },
      isActive1: true,
      isActive2: false,
      isActive3: false,
      imgSrc: "",
      signData: null,

      isResizeScreen: false,
      showOverlay: false,
      isFull: false,
      signatureBase64: "",
      imgUrl: "",

      formData: {},
      loanInfo: {},
      dateData: {
        startDate: {
          year: "",
          month: "",
          date: ""
        }, endDate: {
          year: "",
          month: "",
          date: ""
        }
      },


    };
  },
  watch: {
    show(newVal) {
      this.isShow = newVal;
    },
  },
  computed: {
    address() {
      let str = this.formData.home_region_1_value;
      if (this.formData.home_region_2_value) {
        str += "/" + this.formData.home_region_2_value;
      }
      if (this.formData.home_address) {
        str += this.formData.home_address;
      }

      return str;
    }
  },
  created() {
    this.init();
  },
  methods: {
    signature() {
      this.isShowDrawing = true;
      this.$nextTick(() => {
        this.enterFullscreen();
        this.renderResize();
      })
    },
    cancelSignature() {
      this.isShowDrawing = false;
      this.$nextTick(() => {
        this.exitFullscreen();
      })
    },
    confirmSignature() {
      this.save();
      this.isShowDrawing = false;
      this.$nextTick(() => {
        this.exitFullscreen();
      })
    },
    reSign() {
      this.signatureBase64 = "";
      this.clear();
    },
    confirmationSignature() {
      if (!this.signatureBase64) {
        Toast("請點擊進行簽名")
        return;
      }
      html2canvas(this.$refs.imageDom).then(canvas => {
        // 转成图片，生成图片地址
        this.imgUrl = canvas.toDataURL("image/png");
        let file = this.dataURLtoBlob(this.imgUrl);
        // lrzUploadImage(file, "uploadContract", (res) => {
        //   console.log("上传成功",res)
        //   if(res){
        this.$emit("confirmationSignature", file);
        //   }
        // });
        console.log("file", file)
      });
    },
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], Date.now() + ".png", {
        type: mime
      });
    },
    // getPageNum () {
    //   let loadingTask = Pdf.createLoadingTask(this.file)
    //   loadingTask.promise.then(pdf => {
    //     this.pageNum = pdf.numPages
    //   }).catch(err => {
    //     console.error('pdf加载失败', err);
    //   })
    // },
    //撤销
    undo() {
      this.$refs.signaturePad.undoSignature();
    },
    //清除
    clear() {
      this.$refs.signaturePad.clearSignature();
    },
    //保存
    save() {
      const {isEmpty, data} = this.$refs.signaturePad.saveSignature();
      console.log(isEmpty);
      console.log(data);
      this.signatureBase64 = data;
      if (isEmpty) {
        this.signatureBase64 = "";
      }
    },
    //监听方法
    renderResize() {
      const _this = this;
      _this.isResizeScreen = false;
      _this.showOverlay = false;
      let width = document.documentElement.clientWidth,
          height = document.documentElement.clientHeight,
          // $wrapper = _this.$refs.view, // 这里是页面最外层元素
          style = "";
      if (_this.isShowDrawing) {
        if (width >= height) {
          _this.showOverlay = false;
          console.log("横屏!!!!!")
        } else {
          _this.showOverlay = true;
          console.log("竖屏!!!!!")
        }
        console.log("style", style)
        // $wrapper.style.cssText = style;
        _this.isResizeScreen = true;
        _this.$forceUpdate();
        _this.$nextTick(() => {
          setTimeout(() => {
            console.log("_this.$refs", _this.$refs)
            _this.$refs.signaturePad.resizeCanvas();
          }, 500)
        })
      }

    },
    change() {
      this.isFull = screenfull.isFullscreen  // 更新全屏状态
    },
    enterFullscreen() {
      // const element = document.documentElement;
      // if (element.requestFullscreen) {
      //   element.requestFullscreen();
      // } else if (element.mozRequestFullScreen) {
      //   element.mozRequestFullScreen();
      // } else if (element.webkitRequestFullscreen) {
      //   element.webkitRequestFullscreen();
      // } else if (element.msRequestFullscreen) {
      //   element.msRequestFullscreen();
      // }
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    },
    exitFullscreen() {
      // const element = document.documentElement;
      // if (element.exitFullscreen) {
      //   element.exitFullscreen();
      // }
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    },
    init() {
      this.getUserBase();
      this.getLoanInformation();
    },
    async getUserBase() {
      let userBase = await queryUserBase();
      if (userBase.code == 200) {
        this.formData = userBase.result;
        console.log("this.formData", this.formData)
      }
    },
    async getLoanInformation() {
      let mchId = this.$route.query.mchId;
      let loanInfo = await loanInformation({mchId});
      if (loanInfo.code == 200) {
        this.loanInfo = loanInfo.result;
        console.log("this.loanInfo", this.loanInfo)
        this.getYearToDate();
      }
    },
    getYearToDate() {
      let year = moment().year()
      let month = moment().month() + 1
      let date = moment().date();
      let startDate = {
        year: year - 1911,
        month,
        date
      }
      let endDate = {
        year: moment().add(this.loanInfo.duration, 'days').year() - 1911,
        month: moment().add(this.loanInfo.duration, 'days').month() + 1,
        date: moment().add(this.loanInfo.duration, 'days').date()
      }
      this.dateData = {
        startDate,
        endDate
      };
      console.log(this.dateData)
    }
  },
  mounted() {
    if (screenfull.isEnabled) {
      screenfull.on('change', this.change)		// 开启监听
    }
    window.addEventListener("resize", this.renderResize, false);
    // this.getPageNum()
    // this.signature();

  },
  beforeDestroy() {
    if (screenfull.isEnabled) {
      screenfull.off('change', this.change)
    }
    window.removeEventListener("resize", this.renderResize, false);
  },
};
</script>

<style lang="less" scoped>
.swipeHint {
  /deep/ .van-overlay {
    background: rgba(101, 101, 101, 0.2);
    backdrop-filter: blur(3px);
  }
}

.popup_box {
  width: 100vw;
  height: 100vh;
  border-radius: 0px;
  box-sizing: border-box;
  background: none;
  overflow: hidden;

  .container {
    position: relative;
    width: 100%;
    height: 100%;
    background: #F5F5F5;
    // overflow: auto;
    border-radius: 0px;
    overflow-y: auto;
  }

  .signaturePad {
    position: relative;
    width: 100%;
    height: 100%;
    background: #F5F5F5;
    // overflow: auto;
    border-radius: 0px;

    .signaturePad_content {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: flex-start;
      justify-content: center;
      //flex-wrap: wrap;

      .signaturePad_content_text {
        display: flex;
        align-items: center;
        //flex-flow: column;
        justify-content: space-around;
        flex-wrap: wrap;
        overflow-y: auto;
        width: 90px;
        height: 100%;

        .signaturePad_content_btn {
          margin: 0 10px;
          padding: 5px 16px;
          background: #0090C2;
          border-radius: 8px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;

          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;
          letter-spacing: 1px;
        }
      }

      .popup_content_SignaturePad {
        flex: 1;
        width: 100%;
        height: 100%;
        background-color: #FFFFFF;
      }
    }
  }

  .contract_signature_img_box {
    height: 150px;
    background-color: #FFFFFF;
    margin: 15px;
    box-sizing: border-box;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #6c6d6f;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .contract_signature_btn_box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .popup_close {
    margin: 10px auto;
    margin-bottom: 0;
    width: 138px;
    height: 43px;
    background: #0090C2;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;

    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    letter-spacing: 1px;
  }

  .popup_close2 {
    width: fit-content;
    background: transparent;
    border: none;
  }
}

.contract {
  background-color: #fff;
  padding: 5px;
  box-sizing: border-box;

  .signatureOfAContract_box {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    width: 100%;
  }

  .signatureOfAContract {
    width: 200px;
    border-bottom: 1px solid #4c4c4c;
  }

  .contract_tips {
    border: 1px solid #000000;
    padding: 6px;
    box-sizing: border-box;
  }

  p {
    margin: 6px 0;

    &:first-child {
      text-align: center;
    }
  }
}

.contract_signature {
  background-color: #0090C2;
  padding: 10px;
  padding-bottom: 20px;
  box-sizing: border-box;

  .contract_signature_title {

    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }
}

/deep/ .popup_flip_overlay {
  background: rgba(0, 0, 0, 0.5) !important;
}

.popup_flip_box {

  border-radius: 0px;
  box-sizing: border-box;
  background: none;

  .popup_flip_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    height: 100%;
    background-color: transparent;
    color: #FFFFFF;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;

    img {
      width: 50px;
      height: 50px;
      margin-top: 6px;
    }
  }
}

</style>
